// extracted by mini-css-extract-plugin
export default {"container":"Chat_container__tUvyF","head":"Chat_head__QdaiG","chat":"Chat_chat__wR4wY","send":"Chat_send__PVcJX","empty":"Chat_empty__WwJXi"};